export const handleError = error => {
  console.log(error)
}
